import React, { useContext } from 'react';
import { enrollmentContext } from '../../../../../hoc/context/enrollment/enrollment-context';
import ReviewGroup from '../item/item-group';
import {
	capitalize,
	formatDate,
} from '../../../../../hoc/components/inputs/common-functions';
import context from '../../../../../hoc/context/product/context';
import { PerformerConstants } from '../../../../../hoc/constants/performer.constants';

const PersonalInfo: React.FC<{ suffix?: string }> = ({ suffix = '' }) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);

	// Data structure to be shown
	const data = [
		{
			label: ctxt.json.pages.review.enrollmentName,
			value:
				capitalize(
					enrollmentCtxt
						.getFormField('firstname' + suffix)
						?.value.trim() as string
				) +
				' ' +
				capitalize(
					enrollmentCtxt
						.getFormField('lastname' + suffix)
						?.value.trim() as string
				),
		},
	];
	if (enrollmentCtxt.getFormField('dob' + suffix)?.value) {
		data.push({
			label: ctxt.json.pages.review.enrollmentDob,
			value: formatDate(
				enrollmentCtxt.getFormField('dob' + suffix)?.value as string
			),
		});
	}
	data.push({
		label: ctxt.json.pages.review.enrollmentGender,
		value:
			ctxt.json.pages.review[
				`enrollment_gender_${
					enrollmentCtxt.getFormField('gender' + suffix)?.value
				}`
			],
	});
	if (
		ctxt.json
			.getForm('patientDetails')
			?.fields.find((item) => item.name === 'medication') &&
		!suffix
	) {
		data.push({
			label: ctxt.json.pages.review.servicefieldMedicationLabel,
			value: enrollmentCtxt.getFormField('medication')?.value,
		});
	}
	let separator = ' ';
	if (enrollmentCtxt.getFormField('apt')?.value) {
		separator = ', ';
	}
	if (
		ctxt.json.getForm('caregiverDetails') &&
		enrollmentCtxt.input.performer === PerformerConstants.caregiver &&
		!suffix
	) {
		data.push({
			label: ctxt.json.pages.review.enrollmentMail,
			value:
				'<p>' +
				enrollmentCtxt.getFormField('mail')?.value +
				separator +
				enrollmentCtxt.getFormField('apt')?.value +
				'</p><p>' +
				enrollmentCtxt.getFormField('city')?.value +
				', ' +
				enrollmentCtxt.getFormField('state')?.value +
				' ' +
				enrollmentCtxt.getFormField('zip')?.value +
				'</p>',
		});
	}

	return <ReviewGroup items={data} />;
};

export default PersonalInfo;
